import { c as _c } from "react/compiler-runtime";
import { shopAsset } from '@utils/utils-config';
import Image from 'next/image';
import { TrustedLogo } from './trusted-logo';
import { TrustedStars } from './trusted-stars';
type ReviewCardProps = {
  authorName: string;
  country: string;
  rating: number;
  text: string;
  verified: boolean;
};
export function ReviewCard(t0) {
  const $ = _c(23);
  const {
    authorName,
    country,
    rating,
    text,
    verified
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Image src={shopAsset("/images/guide-placeholder.png")} alt="Avatar" width={40} height={40} className="rounded-xl" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== authorName) {
    t2 = <div className="font-body-small font-semibold">{authorName}</div>;
    $[1] = authorName;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== country) {
    t3 = <div className="font-body-small">{country}</div>;
    $[3] = country;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className="flex items-center gap-2">{t1}<div>{t2}{t3}</div></div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== rating) {
    t5 = <div className="flex items-center gap-1"><TrustedStars rating={rating} direction="ltr" /></div>;
    $[8] = rating;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== verified) {
    t6 = verified && <div className="flex items-center gap-2"><TrustedLogo width={24} height={24} /><span className="text-lg text-primary">Verifiziert</span></div>;
    $[10] = verified;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <div className="flex items-center justify-between">{t5}{t6}</div>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== text) {
    t8 = <p className="font-body-small">{text}</p>;
    $[15] = text;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t7 || $[18] !== t8) {
    t9 = <div className="flex flex-col gap-2">{t7}{t8}</div>;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t4 || $[21] !== t9) {
    t10 = <article className="flex flex-col gap-4 rounded-xl border border-primary/15 p-4">{t4}{t9}</article>;
    $[20] = t4;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
}